import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/reset-password")({
  head: () => ({
    meta: [
      { title: "Redefinir senha — Projeto 101" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setMsg(null);
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) {
      setErr(error.message);
      return;
    }
    setMsg("Senha atualizada. Redirecionando...");
    setTimeout(() => navigate({ to: "/membros", replace: true }), 1500);
  }

  return (
    <div className="min-h-screen bg-[var(--beige)] font-body text-[var(--navy)]">
      <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-6 py-10">
        <div className="rounded-2xl border border-black/5 bg-white p-8 shadow-sm">
          <h1 className="font-display text-2xl font-extrabold">Redefinir senha</h1>
          <p className="mt-1 text-sm text-[var(--gray-ink)]">
            Crie uma nova senha para sua conta.
          </p>
          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nova senha"
              className="w-full rounded-md border border-black/10 bg-white px-3 py-2 text-sm outline-none focus:border-[var(--green)]"
            />
            {err && <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
            {msg && <div className="rounded-md bg-emerald-50 px-3 py-2 text-sm text-emerald-700">{msg}</div>}
            <button
              disabled={loading}
              className="w-full rounded-md bg-[var(--navy)] px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-60"
            >
              {loading ? "Salvando..." : "Atualizar senha"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
